/* AK Bodyfashion · v0.5: levertijd per maatknop en gekozen maat weer uitzetten. */
(() => {
  const rank = { stock: 3, order: 2, later: 2, backorder: 2 };

  const setup = (section) => {
    if (section.dataset.akSizes) return;
    section.dataset.akSizes = '1';
    let states = null;
    try { states = JSON.parse(section.querySelector('[data-variant-states]')?.textContent || 'null'); } catch { states = null; }
    const fieldsets = () => [...section.querySelectorAll('[data-option-index]')];
    const resettable = (fs) => fs.dataset.optionKind !== 'color' && fs.querySelectorAll('.size-input').length > 1;
    const selected = () => fieldsets().map((fs) => fs.querySelector('.size-input:checked')?.value ?? null);

    const mark = () => {
      const sel = selected();
      const reset = section.querySelector('[data-size-reset]');
      if (reset) reset.hidden = !fieldsets().some((fs, i) => sel[i] !== null && resettable(fs));
      if (!states) return;
      fieldsets().forEach((fs, i) => {
        fs.querySelectorAll('.size-input').forEach((input) => {
          const label = fs.querySelector(`label[for="${input.id}"]`);
          if (!label) return;
          let best = 0;
          states.forEach((v) => {
            if (String(v.o[i]) !== input.value) return;
            if (!sel.every((s, j) => j === i || s === null || String(v.o[j]) === s)) return;
            best = Math.max(best, rank[v.s] || 0);
          });
          if (best === 3) label.dataset.st = 'stock';
          else if (best === 2) label.dataset.st = 'order';
          else delete label.dataset.st;
        });
      });
    };

    const clearUrl = () => {
      const u = new URL(location.href);
      if (!u.searchParams.has('variant')) return;
      u.searchParams.delete('variant');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    };

    const uncheck = (inputs) => {
      inputs.forEach((i) => { i.checked = false; });
      clearUrl();
      mark();
      // Laat de bestaande maatkiezer opnieuw rekenen (knop, status, levertijd).
      inputs[0]?.dispatchEvent(new Event('change', { bubbles: true }));
    };

    section.addEventListener('click', (e) => {
      const label = e.target.closest('label.size-option');
      if (label) {
        const input = document.getElementById(label.htmlFor);
        const fs = input?.closest('[data-option-index]');
        if (!input || !input.checked || !fs || !resettable(fs)) return;
        e.preventDefault();
        uncheck([input]);
        return;
      }
      if (e.target.closest('[data-size-reset]')) {
        const inputs = fieldsets().filter(resettable).flatMap((fs) => [...fs.querySelectorAll('.size-input:checked')]);
        uncheck(inputs);
      }
    });
    section.addEventListener('change', (e) => { if (e.target.matches('.size-input')) mark(); });
    mark();
  };

  const init = () => document.querySelectorAll('[data-variant-states], [data-size-reset]').forEach((el) => {
    const section = el.closest('[data-section-id]');
    if (section) setup(section);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Cupmaatcalculator */
(() => {
  const CUPS = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
  const fmt = (n) => String(n).replace('.', ',');

  const calc = (under, over) => {
    const band = Math.round(under / 5) * 5;
    const diff = over - under;
    const idx = Math.floor((diff - 10) / 2);
    if (idx < 0) return { band, cup: null, diff, low: true };
    if (idx >= CUPS.length) return { band, cup: null, diff, high: true };
    return { band, cup: CUPS[idx], idx, diff };
  };

  const update = (dlg) => {
    ['under', 'over'].forEach((k) => {
      const inp = dlg.querySelector(`[data-cc-in="${k}"]`);
      const pct = ((inp.value - inp.min) / (inp.max - inp.min)) * 100;
      inp.style.setProperty('--p', pct + '%');
      dlg.querySelector(`[data-cc-out="${k}"]`).textContent = fmt(Number(inp.value)) + ' cm';
    });
  };

  const showResult = (dlg) => {
    const under = Number(dlg.querySelector('[data-cc-in="under"]').value);
    const over = Number(dlg.querySelector('[data-cc-in="over"]').value);
    const r = calc(under, over);
    let map = null;
    try { map = JSON.parse(dlg.querySelector('[data-cupcalc-map]').textContent); } catch { map = null; }
    const box = dlg.querySelector('[data-cc-result]');
    const size = dlg.querySelector('[data-cc-size]');
    const sister = dlg.querySelector('[data-cc-sister]');
    const go = dlg.querySelector('[data-cc-go]');
    delete go.dataset.ccPick;
    box.hidden = false;
    go.hidden = true;
    if (!r.cup) {
      size.textContent = r.low ? 'Controleer je maten' : `${r.band} en groter dan ${CUPS.at(-1)}`;
      sister.textContent = r.low
        ? 'Je bovenwijdte is bijna gelijk aan je onderwijdte. Meet nog eens over het volste deel van je borsten.'
        : 'Voor deze maat helpen we je graag persoonlijk. Neem even contact met ons op.';
    } else {
      size.textContent = `${r.band}${r.cup}`;
      const alt = [];
      if (r.idx + 1 < CUPS.length && r.band - 5 >= 60) alt.push(`${r.band - 5}${CUPS[r.idx + 1]}`);
      if (r.idx - 1 >= 0) alt.push(`${r.band + 5}${CUPS[r.idx - 1]}`);
      sister.textContent = alt.length ? `Zit de band te strak of te los? Probeer dan ${alt.join(' of ')}.` : '';
      const picker = window.akSizePick;
      const pst = !map && picker ? picker.state(r.band, r.cup) : null;
      if (pst && pst !== 'sold') {
        go.href = '#';
        go.dataset.ccPick = `${r.band}|${r.cup}`;
        go.textContent = `Kies ${r.band}${r.cup}`;
        go.hidden = false;
      } else if (!map && picker) {
        sister.textContent += ` ${r.band}${r.cup} is in dit model ${pst === 'sold' ? 'helaas uitverkocht' : 'niet beschikbaar'}.`;
      }
      const bv = map?.band?.values?.[String(r.band)];
      const cv = map?.cup?.values?.[r.cup];
      if (map && bv && cv) {
        const u = new URL(location.href);
        [map.band.param, map.cup.param, 'page', 'section_id'].forEach((p) => u.searchParams.delete(p));
        u.searchParams.append(map.band.param, bv);
        u.searchParams.append(map.cup.param, cv);
        go.href = u.pathname + u.search;
        go.textContent = `Toon alles in ${r.band}${r.cup}`;
        go.hidden = false;
      }
    }
    dlg.querySelector('[data-cc-calc]').hidden = true;
    dlg.querySelector('[data-cc-again]').hidden = false;
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  const reset = (dlg) => {
    dlg.querySelector('[data-cc-result]').hidden = true;
    const g = dlg.querySelector('[data-cc-go]');
    g.hidden = true;
    delete g.dataset.ccPick;
    dlg.querySelector('[data-cc-calc]').hidden = false;
    dlg.querySelector('[data-cc-again]').hidden = true;
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cupcalc-open]');
    if (open) {
      const dlg = document.getElementById(open.dataset.cupcalcOpen);
      if (!dlg) return;
      update(dlg);
      dlg.showModal();
      document.body.classList.add('dialog-open');
      return;
    }
    const dlg = e.target.closest('[data-cupcalc]');
    if (!dlg) return;
    if (e.target === dlg || e.target.closest('[data-cupcalc-close]')) { dlg.close(); return; }
    const step = e.target.closest('[data-cc-step]');
    if (step) {
      const inp = dlg.querySelector(`[data-cc-in="${step.dataset.ccStep}"]`);
      inp.value = Math.min(inp.max, Math.max(inp.min, Number(inp.value) + 0.5 * Number(step.dataset.dir)));
      update(dlg); reset(dlg);
      return;
    }
    const pickBtn = e.target.closest('[data-cc-pick]');
    if (pickBtn) {
      e.preventDefault();
      const [b, c] = pickBtn.dataset.ccPick.split('|');
      window.akSizePick?.pick(b, c);
      dlg.close();
      return;
    }
    if (e.target.closest('[data-cc-calc]')) showResult(dlg);
    if (e.target.closest('[data-cc-again]')) reset(dlg);
  });
  document.addEventListener('input', (e) => {
    const dlg = e.target.closest?.('[data-cupcalc]');
    if (!dlg || !e.target.matches('[data-cc-in]')) return;
    if (e.target.dataset.ccIn === 'under') {
      const over = dlg.querySelector('[data-cc-in="over"]');
      if (Number(over.value) < Number(e.target.value) + 10) over.value = Number(e.target.value) + 12;
    }
    update(dlg); reset(dlg);
  });
  document.addEventListener('close', (e) => {
    if (e.target.matches?.('[data-cupcalc]')) document.body.classList.remove('dialog-open');
  }, true);
})();

/* Maatlijst in zijpaneel: bh's (omvang + cup) en kleding met één maat-optie */
(() => {
  const CUP_ORDER = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'I', 'J', 'JJ', 'K', 'L', 'M', 'N'];
  const cupRank = (c) => { const i = CUP_ORDER.indexOf(String(c).toUpperCase()); return i < 0 ? 99 : i; };
  const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));

  const setup = (section) => {
    const field = section.querySelector('[data-akz]');
    const dlg = section.querySelector('[data-akz-dialog]');
    if (!field || !dlg || field.dataset.ready) return;
    field.dataset.ready = '1';
    let states = [];
    try { states = JSON.parse(section.querySelector('[data-variant-states]')?.textContent || '[]'); } catch { states = []; }
    const bra = field.dataset.mode === 'bra';
    const bi = Number(field.dataset.band);
    const ci = Number(field.dataset.cup);
    const si = Number(field.dataset.size);
    const keys = bra ? [bi, ci] : [si];
    const fs = (i) => section.querySelector(`[data-option-index="${i}"]`);
    const order = bra ? [] : [...(fs(si)?.querySelectorAll('.size-input') || [])].map((i) => i.value);
    const label = (st) => ({
      stock: 'Op voorraad', none: 'Op voorraad', order: field.dataset.lead, later: field.dataset.later || 'Later leverbaar',
      backorder: 'Nabestelbaar', sold: 'Uitverkocht', soldlater: laterText
    }[st] || '');
    const banner = section.querySelector('.pdp-later');
    const bannerText = banner?.querySelector('p');
    const updateBanner = (st) => {
      if (!banner) return;
      const show = st === 'sold' || st === 'later' || st === 'soldlater';
      banner.style.display = show ? '' : 'none';
      if (show && bannerText) {
        bannerText.textContent = st === 'later'
          ? 'Je kunt deze maat nu al bestellen. We versturen hem zodra hij binnen is.'
          : 'Deze maat is tijdelijk uitverkocht. Kies een andere maat, of vraag ons of we hem voor je kunnen reserveren.';
      }
    };
    const laterText = field.dataset.later || '';
    // Met een 'leverbaar vanaf'-datum tonen uitverkochte maten die datum in plaats van 'Uitverkocht'.
    const eff = (st) => (st === 'sold' && laterText ? 'soldlater' : st);
    const cls = (st) => (st === 'none' ? 'stock' : st === 'later' || st === 'backorder' || st === 'soldlater' ? 'order' : st || 'none');
    let tab = 'all';

    const others = () => [...section.querySelectorAll('[data-option-index]')]
      .map((f) => Number(f.dataset.optionIndex))
      .filter((i) => !keys.includes(i))
      .map((i) => [i, fs(i)?.querySelector('.size-input:checked')?.value ?? null]);

    const rows = () => {
      const oth = others();
      const seen = new Set();
      return states
        .filter((v) => oth.every(([i, val]) => val === null || String(v.o[i]) === val))
        .map((v) => ({ vals: keys.map((i) => String(v.o[i])), st: eff(v.s) }))
        .map((r) => ({ ...r, key: r.vals.join('|'), name: r.vals.join(''), cup: bra ? r.vals[1] : null }))
        .filter((r) => { if (seen.has(r.key)) return false; seen.add(r.key); return true; })
        .sort((a, b) => bra
          ? cupRank(a.cup) - cupRank(b.cup) || a.cup.localeCompare(b.cup) || parseFloat(a.vals[0]) - parseFloat(b.vals[0])
          : order.indexOf(a.vals[0]) - order.indexOf(b.vals[0]));
    };

    const current = () => keys.map((i) => fs(i)?.querySelector('.size-input:checked')?.value ?? null);
    const state = (...vals) => rows().find((r) => r.key === vals.map(String).join('|'))?.st ?? null;

    const extraFs = () => [...section.querySelectorAll('[data-option-index]')]
      .filter((f) => !keys.includes(Number(f.dataset.optionIndex)) && f.querySelectorAll('.size-input').length > 1);

    const renderExtra = () => {
      const box = dlg.querySelector('[data-akz-extra]');
      if (!box) return;
      box.innerHTML = extraFs().map((f) => {
        const i = Number(f.dataset.optionIndex);
        const cur = f.querySelector('.size-input:checked')?.value;
        const btns = [...f.querySelectorAll('.size-input')].map((inp) => {
          const lab = f.querySelector(`label[for="${inp.id}"]`);
          const any = states.some((v) => String(v.o[i]) === inp.value && v.s !== 'sold');
          return `<button type="button" aria-pressed="${inp.value === cur}" class="${any ? '' : 'is-out'}" data-akz-opt="${i}" data-val="${esc(inp.value)}">${lab ? lab.innerHTML : esc(inp.value)}</button>`;
        }).join('');
        return `<div class="akz-opt"><span class="akz-opt-title">${esc(f.dataset.optionName)}${cur ? `: <b>${esc(cur)}</b>` : ''}</span><div class="akz-opt-values">${btns}</div></div>`;
      }).join('');
    };

    const render = () => {
      renderExtra();
      const all = rows();
      const tabs = dlg.querySelector('[data-akz-tabs]');
      if (bra) {
        const cups = [...new Set(all.map((r) => r.cup))];
        if (tab !== 'all' && !cups.includes(tab)) tab = 'all';
        tabs.innerHTML = ['all', ...cups].map((c) =>
          `<button type="button" role="tab" aria-selected="${c === tab}" data-akz-tab="${esc(c)}">${c === 'all' ? 'Alle' : esc(c)}</button>`).join('');
      } else {
        tabs.hidden = true;
      }
      const cur = current().join('|');
      dlg.querySelector('[data-akz-list]').innerHTML = all.filter((r) => !bra || tab === 'all' || r.cup === tab).map((r) => {
        const sold = r.st === 'sold';
        return `<li><button type="button" role="option" aria-selected="${cur === r.key}" class="akz-row is-${cls(r.st)}"${sold ? ' aria-disabled="true"' : ''} data-akz-pick="${esc(r.key)}">
          <span class="akz-size">${esc(r.name)}</span><span class="akz-state"><i aria-hidden="true"></i>${esc(label(r.st))}</span></button></li>`;
      }).join('') || '<li class="akz-empty">Kies eerst een kleur.</li>';
    };

    const updateCurrent = () => {
      const cur = current();
      const main = field.querySelector('[data-akz-current]');
      const st = field.querySelector('[data-akz-current-state]');
      const btn = field.querySelector('[data-akz-open]');
      const extra = extraFs().map((f) => f.querySelector('.size-input:checked')?.value).filter(Boolean);
      if (cur.every((v) => v !== null)) {
        const s2 = state(...cur);
        main.textContent = [...extra, cur.join('')].join(' · ');
        st.textContent = label(s2);
        st.className = `akz-select-state is-${cls(s2)}`;
        btn.classList.add('is-set');
        updateBanner(s2);
      } else {
        main.textContent = extra.length ? `${extra.join(' · ')} · kies je maat` : (extraFs().length ? 'Kies je kleur en maat' : 'Kies je maat');
        st.textContent = '';
        st.className = 'akz-select-state';
        btn.classList.remove('is-set');
        updateBanner(null);
      }
    };

    const pick = (...vals) => {
      const inputs = keys.map((i, n) => [...(fs(i)?.querySelectorAll('.size-input') || [])].find((x) => x.value === String(vals[n])));
      if (inputs.some((x) => !x)) return false;
      inputs.forEach((x) => { x.disabled = false; x.checked = true; });
      inputs.at(-1).dispatchEvent(new Event('change', { bubbles: true }));
      updateCurrent();
      return true;
    };
    if (bra) window.akSizePick = { state, pick };

    const open = () => {
      render();
      dlg.showModal();
      document.body.classList.add('dialog-open');
      dlg.querySelector('.akz-row[aria-selected="true"]')?.scrollIntoView({ block: 'center' });
    };

    section.addEventListener('click', (e) => {
      if (e.target.closest('[data-akz-open]')) { open(); return; }
      if (!e.target.closest('[data-akz-dialog]')) return;
      if (e.target === dlg || e.target.closest('[data-akz-close]')) { dlg.close(); return; }
      if (e.target.closest('[data-cupcalc-open], [data-action="size-guide"]')) { dlg.close(); return; }
      const ob = e.target.closest('[data-akz-opt]');
      if (ob) {
        const f = fs(Number(ob.dataset.akzOpt));
        const inp = [...(f?.querySelectorAll('.size-input') || [])].find((x) => x.value === ob.dataset.val);
        if (inp) {
          inp.disabled = false;
          inp.checked = true;
          const lbl = f.querySelector('[data-selected-label]');
          if (lbl) lbl.textContent = inp.value;
          // Bestaat de gekozen maat niet in deze kleur, dan de maat loslaten.
          const cur = current();
          if (cur.every((v) => v !== null) && !state(...cur)) keys.forEach((k) => { const c = fs(k)?.querySelector('.size-input:checked'); if (c) c.checked = false; });
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          render();
          updateCurrent();
        }
        return;
      }
      const t = e.target.closest('[data-akz-tab]');
      if (t) { tab = t.dataset.akzTab; render(); return; }
      const row = e.target.closest('[data-akz-pick]');
      if (row && row.getAttribute('aria-disabled') !== 'true') {
        pick(...row.dataset.akzPick.split('|'));
        dlg.close();
      }
    });
    dlg.addEventListener('close', () => document.body.classList.remove('dialog-open'));
    section.addEventListener('change', (e) => { if (e.target.matches('.size-input')) updateCurrent(); });
    updateCurrent();
  };

  const init = () => document.querySelectorAll('[data-akz]').forEach((f) => {
    const section = f.closest('[data-section-id]');
    if (section) setup(section);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
